import { createFileRoute } from "@tanstack/react-router";
import { AgenturVorschau } from "@/pages/team/AgenturVorschau";

/**
 * Die Team-Vorschau auf den Kundenbereich eines bestimmten Kunden: Bei
 * Agenturen das Partner-Dashboard (Aufträge, Endkunden, Phasen), bei
 * Direktkunden der Projektstand — erreichbar über das Auge in der
 * Kundenliste. Nur Ansicht; gemeldet wird aus dem echten Agentur-Login.
 */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/agentur-vorschau/$kundeId")({
	component: Seite,
});

function Seite() {
	const { kundeId } = Route.useParams();
	return <AgenturVorschau kundeId={kundeId} />;
}
